import { Controller, useFormContext } from 'react-hook-form';

import type { DateRangePreset } from '~shared/ui/date-range-picker';
import { DateRangePicker } from '~shared/ui/date-range-picker';

import {
  endOfDay,
  startOfDay,
  startOfMonth,
  subMonths,
  subWeeks,
} from 'date-fns';

import type { DashboardFiltersValue } from '../model/dashboard-filters';

const PERIOD_PRESETS: DateRangePreset[] = [
  {
    title: 'Last 7 days',
    value: {
      startDate: startOfDay(subWeeks(new Date(), 1)).toISOString(),
      endDate: endOfDay(new Date()).toISOString(),
    },
  },
  {
    title: 'Last 14 days',
    value: {
      startDate: startOfDay(subWeeks(new Date(), 2)).toISOString(),
      endDate: endOfDay(new Date()).toISOString(),
    },
  },
  {
    title: 'Last month',
    value: {
      startDate: startOfDay(subMonths(new Date(), 1)).toISOString(),
      endDate: endOfDay(new Date()).toISOString(),
    },
  },
];

type Props = {
  onChange?: () => void;
};

export function DashboardPeriodFilter({ onChange }: Props) {
  const { control } = useFormContext<DashboardFiltersValue>();
  const minDate = startOfDay(startOfMonth(subMonths(new Date(), 1)));
  const maxDate = endOfDay(new Date());

  return (
    <Controller
      control={control}
      name="period"
      render={({ field, ...controllerProps }) => (
        <DateRangePicker
          {...controllerProps}
          field={{
            ...field,
            onChange: (period: DashboardFiltersValue['period']) => {
              field.onChange(period);

              const isComplete = Boolean(period.startDate && period.endDate);
              const isCleared = !period.startDate && !period.endDate;

              if (isComplete || isCleared) {
                onChange?.();
              }
            },
          }}
          align="end"
          minDate={minDate}
          maxDate={maxDate}
          presets={PERIOD_PRESETS}
        />
      )}
    />
  );
}
